import { useState, useEffect } from "react";
import SidebarShell from "../layout/SidebarShell";
import SectionSubNav from "../layout/SectionSubNav";

export default function DataManagementSidebar() {
  const [collapsed, setCollapsed] = useState(() =>
    localStorage.getItem("data-management-sidebar-collapsed") === "true"
  );

  useEffect(() => {
    const handler = () =>
      setCollapsed(localStorage.getItem("data-management-sidebar-collapsed") === "true");
    window.addEventListener("data-management-sidebar-toggle", handler);
    return () => window.removeEventListener("data-management-sidebar-toggle", handler);
  }, []);

  return (
    <SidebarShell
      collapsed={collapsed}
      sidebarType="data-management"
      sectionNav={<SectionSubNav section="data-management" collapsed={collapsed} />}
    />
  );
}
